import { useState } from "react";
import clinicAPI from "../../../services/clinicApi";
import { Button, useToast } from "../../ui";

/** Отмена выдачи без принятых оплат (pending или active с долгом). */
export default function CancelPendingMembershipButton({
  membership,
  onSuccess,
  size = "sm",
}) {
  const toast = useToast();
  const [busy, setBusy] = useState(false);

  const paid = Number(membership?.paid_total || 0);
  const canCancel =
    membership &&
    (membership.status === "pending" ||
      ((membership.status === "active" || membership.status === "frozen") &&
        paid <= 0));

  if (!canCancel) return null;

  const cancel = async () => {
    if (
      !window.confirm(
        membership.status === "pending"
          ? "Отменить неоплаченный абонемент? Клиент сможет оформить заказ заново."
          : "Отменить выдачу? Абонемент перестанет действовать, долг исчезнет. Отметки «Был» по этому абонементу перестанут списывать занятия с него.",
      )
    ) {
      return;
    }
    setBusy(true);
    try {
      const res = await clinicAPI.cancelClientMembership(membership.id);
      if (res.status === "confirmed") {
        toast.success(
          res.message || "Оплата уже прошла — абонемент активирован",
        );
      } else {
        toast.success("Абонемент отменён");
      }
      onSuccess?.(res);
    } catch (err) {
      toast.error(err.response?.data?.error || "Не удалось отменить");
    } finally {
      setBusy(false);
    }
  };

  return (
    <Button
      type="button"
      size={size}
      variant="secondary"
      disabled={busy}
      onClick={cancel}
    >
      {busy ? "…" : "Отменить выдачу"}
    </Button>
  );
}
